module.exports = __webpack_public_path__ + "img/apple_store_stars.574e656c.svg";